import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {subWeeks} from "date-fns";
import SelectComponent from "../../../../components/select/select-component.jsx";
import UseReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const {
        natureGroups,
        natureActions,
    } = UseReportFiltersFetch({
        fetchNatureActions: true,
        fetchNatureGroups: true
    });

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtStart: subWeeks(new Date(), 1) }));
                        }
                    }}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtEnd: new Date() }));
                        }
                    }}
                />
                <SelectComponent
                    id="nature"
                    label="Naturezas"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={natureActions}
                    value={filters.nature}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature: value }))}
                />
                <SelectComponent
                    id="natureGroups"
                    label="Grupo de naturezas"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={natureGroups}
                    value={filters.natureGroups}
                    onChange={(value) => setFilters(prev => ({ ...prev, natureGroups: value }))}
                />
            </form>
        </div>
    )
}